<p-dialog [(visible)]="showModal" [draggable]="false" [resizable]="false" [modal]="true" [ngStyle]="{ width: '100px' }"
  [dismissableMask]="dismissableMask" [closable]="showCloseBtn" class="z-modal w-800">
  <ng-template pTemplate="header">
    <h2 class="z-titulo z-naranja z-center">
      <strong>{{ textHeader }}</strong>
    </h2>
  </ng-template>
  <ng-template pTemplate="content">
    <p [innerHTML]="textContent"></p>

    <div class="z-separador h-50"></div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="centrar">
      <a href="javascript:void(0)" *ngIf="showBtnOk" type="button" (click)="handleOk()" class="z-btn z-btn-primary">{{
        textHandleOk }}</a>
    </div>
  </ng-template>
</p-dialog>